import { useTranslation } from 'react-i18next';

export default function StatisticsPage() {
  const { t } = useTranslation();

  return (
    <main className="max-w-7xl mx-auto px-6 py-8">
      <h2 className="modal-title mb-6">{t('nav.statistics')}</h2>
      <p className="text-sm text-gray-400">Indhold kommer snart.</p>
    </main>
  );
}
